/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { FinishRegisterUserCommand as AceXFoundPortalCoreCaqAuthenticationCommandsFinishRegisterUserCommand } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Commands/finish-register-user-command';
import { RegisterUserCommand as AceXFoundPortalCoreCaqAuthenticationCommandsRegisterUserCommand } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Commands/register-user-command';
import { ResetPasswordCommand as AceXFoundPortalCoreCaqAuthenticationCommandsResetPasswordCommand } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Commands/reset-password-command';
import { UserCredentialAuthenticationRequest as AceXFoundPortalCoreCaqAuthenticationRequestsUserCredentialAuthenticationRequest } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Requests/user-credential-authentication-request';
import { VerifyPasswordResetRequest as AceXFoundPortalCoreCaqAuthenticationRequestsVerifyPasswordResetRequest } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Requests/verify-password-reset-request';
import { VerifyRegistrationRequest as AceXFoundPortalCoreCaqAuthenticationRequestsVerifyRegistrationRequest } from '../models/ace/xFound/Portal/Core/CAQ/Authentication/Requests/verify-registration-request';

@Injectable({
providedIn: 'root',
})
export class AuthenticationService extends AuthBaseService {
constructor(
config: ApiConfiguration,
http: HttpClient
) {
super(config, http);
}


  /**
   * Path part for operation apiAuthenticationLoginPost
   */
  static readonly ApiAuthenticationLoginPostPath = '/api/Authentication/Login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationLoginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationLoginPost$Plain$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsUserCredentialAuthenticationRequest
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationLoginPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: 'text/plain'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationLoginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationLoginPost$Plain(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsUserCredentialAuthenticationRequest
  }): Observable<string> {

    return this.apiAuthenticationLoginPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationLoginPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationLoginPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsUserCredentialAuthenticationRequest
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationLoginPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'json',
        accept: 'text/json'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationLoginPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationLoginPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsUserCredentialAuthenticationRequest
  }): Observable<string> {

    return this.apiAuthenticationLoginPost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiAuthenticationRefreshTokenPost
   */
  static readonly ApiAuthenticationRefreshTokenPostPath = '/api/Authentication/RefreshToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationRefreshTokenPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRefreshTokenPost$Plain$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationRefreshTokenPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: 'text/plain'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationRefreshTokenPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRefreshTokenPost$Plain(params?: {
    body?: Array<string>
  }): Observable<string> {

    return this.apiAuthenticationRefreshTokenPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationRefreshTokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRefreshTokenPost$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationRefreshTokenPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'json',
        accept: 'text/json'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationRefreshTokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRefreshTokenPost(params?: {
    body?: Array<string>
  }): Observable<string> {

    return this.apiAuthenticationRefreshTokenPost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiAuthenticationRegisterPost
   */
  static readonly ApiAuthenticationRegisterPostPath = '/api/Authentication/Register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationRegisterPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRegisterPost$Plain$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsRegisterUserCommand
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: 'text/plain'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationRegisterPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRegisterPost$Plain(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsRegisterUserCommand
  }): Observable<string> {

    return this.apiAuthenticationRegisterPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationRegisterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRegisterPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsRegisterUserCommand
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'json',
        accept: 'text/json'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationRegisterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationRegisterPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsRegisterUserCommand
  }): Observable<string> {

    return this.apiAuthenticationRegisterPost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiAuthenticationFinishRegisterPost
   */
  static readonly ApiAuthenticationFinishRegisterPostPath = '/api/Authentication/FinishRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationFinishRegisterPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationFinishRegisterPost$Plain$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsFinishRegisterUserCommand
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationFinishRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: 'text/plain'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationFinishRegisterPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationFinishRegisterPost$Plain(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsFinishRegisterUserCommand
  }): Observable<string> {

    return this.apiAuthenticationFinishRegisterPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationFinishRegisterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationFinishRegisterPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsFinishRegisterUserCommand
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationFinishRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'json',
        accept: 'text/json'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationFinishRegisterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationFinishRegisterPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsFinishRegisterUserCommand
  }): Observable<string> {

    return this.apiAuthenticationFinishRegisterPost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiAuthenticationLogoutPost
   */
  static readonly ApiAuthenticationLogoutPostPath = '/api/Authentication/Logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationLogoutPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthenticationLogoutPost$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationLogoutPostPath, 'post');
    if (params) {
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationLogoutPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthenticationLogoutPost(params?: {
  }): Observable<void> {

    return this.apiAuthenticationLogoutPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAuthenticationResetPasswordPatch
   */
  static readonly ApiAuthenticationResetPasswordPatchPath = '/api/Authentication/ResetPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationResetPasswordPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationResetPasswordPatch$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsResetPasswordCommand
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationResetPasswordPatchPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationResetPasswordPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationResetPasswordPatch(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationCommandsResetPasswordCommand
  }): Observable<void> {

    return this.apiAuthenticationResetPasswordPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAuthenticationVerifyRegistrationPost
   */
  static readonly ApiAuthenticationVerifyRegistrationPostPath = '/api/Authentication/VerifyRegistration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationVerifyRegistrationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyRegistrationPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyRegistrationRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationVerifyRegistrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationVerifyRegistrationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyRegistrationPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyRegistrationRequest
  }): Observable<void> {

    return this.apiAuthenticationVerifyRegistrationPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAuthenticationVerifyRegistrationInternalPost
   */
  static readonly ApiAuthenticationVerifyRegistrationInternalPostPath = '/api/Authentication/VerifyRegistrationInternal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationVerifyRegistrationInternalPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyRegistrationInternalPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyRegistrationRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationVerifyRegistrationInternalPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationVerifyRegistrationInternalPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyRegistrationInternalPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyRegistrationRequest
  }): Observable<void> {

    return this.apiAuthenticationVerifyRegistrationInternalPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAuthenticationVerifyPasswordResetPost
   */
  static readonly ApiAuthenticationVerifyPasswordResetPostPath = '/api/Authentication/VerifyPasswordReset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthenticationVerifyPasswordResetPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyPasswordResetPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyPasswordResetRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthenticationService.ApiAuthenticationVerifyPasswordResetPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

      return this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAuthenticationVerifyPasswordResetPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAuthenticationVerifyPasswordResetPost(params?: {
    body?: AceXFoundPortalCoreCaqAuthenticationRequestsVerifyPasswordResetRequest
  }): Observable<void> {

    return this.apiAuthenticationVerifyPasswordResetPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}